<template>

  <div class="product-list">
    <CCard>
      <CCardHeader>
        <strong>
          گزارش سئو
        </strong>

      </CCardHeader>

      <CCardBody class="">
        <CTabs>
          <CTab title="آمار بازدید محصولات">

            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="product_views_list"
                :fields="product_views_list_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #change_day="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_day>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_day }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_day) }}
                  </p>
                </td>
              </template>
              <template #change_month="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_month>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_month }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_month) }}
                  </p>
                </td>
              </template>


              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goOrderInfo(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>

          </CTab>
          <CTab title="آمار بازدید مقالات">
            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="post_views_list"
                :fields="product_views_list_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #change_day="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_day>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_day }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_day) }}
                  </p>
                </td>
              </template>
              <template #change_month="{item}">
                <td>
                  <p class="text-success ltr" v-if="item.change_month>=0">
                    <CIcon name="cil-level-up"/>
                    {{ item.change_month }}
                  </p>
                  <p class="text-danger ltr" v-else>
                    <CIcon name="cil-level-down"/>
                    {{ Math.abs(item.change_month) }}
                  </p>
                </td>
              </template>


              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goOrderInfo(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>
          </CTab>
          <CTab title="آمار بازدید روزانه">
            <CRow>
              <CCol>
                <CDataTableFixed
                    class="mb-0 table-outline"
                    hover
                    striped
                    sorter
                    column-filter
                    :pagination="true"
                    :items-per-page="100"
                    :items="product_views_perday"
                    :fields="product_views_perday_fields"
                    head-color="light"
                >
                  <template #row_id="{item,index}">
                    <td>
                      <p>{{ index + 1 }}</p>
                    </td>
                  </template>
                  <template #operation="{item,index}">
                    <td class="py-2">
                      <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          @click="goOrderInfo(item)"
                      >
                        <CIcon name="eye" size="sm"/>
                      </CButton>

                    </td>
                  </template>

                </CDataTableFixed>
              </CCol>
              <CCol>
                <CDataTableFixed
                    class="mb-0 table-outline"
                    hover
                    striped
                    sorter
                    column-filter
                    :pagination="true"
                    :items-per-page="100"
                    :items="post_views_perday"
                    :fields="product_views_perday_fields"
                    head-color="light"
                >
                  <template #row_id="{item,index}">
                    <td>
                      <p>{{ index + 1 }}</p>
                    </td>
                  </template>
                  <template #operation="{item,index}">
                    <td class="py-2">
                      <CButton
                          color="primary"
                          variant="outline"
                          square
                          size="sm"
                          @click="goOrderInfo(item)"
                      >
                        <CIcon name="eye" size="sm"/>
                      </CButton>

                    </td>
                  </template>

                </CDataTableFixed>

              </CCol>
            </CRow>
          </CTab>
          <CTab title="آمار فراوانی محصولات">
            <CDataTableFixed
                class="mb-0 table-outline"
                hover
                striped
                sorter
                column-filter
                :pagination="true"
                :items-per-page="100"
                :items="product_faravani"
                :fields="product_faravani_fields"
                head-color="light"
            >
              <template #row_id="{item,index}">
                <td>
                  <p>{{ index + 1 }}</p>
                </td>
              </template>
              <template #operation="{item,index}">
                <td class="py-2">
                  <CButton
                      color="primary"
                      variant="outline"
                      square
                      size="sm"
                      @click="goOrderInfo(item)"
                  >
                    <CIcon name="eye" size="sm"/>
                  </CButton>

                </td>
              </template>

            </CDataTableFixed>
          </CTab>
          <CTab title="رتبه بندی سئو مقالات">
<BlogSeoRank :blog_posts="blog_posts"/>
          </CTab>

          <CTab title="گزارش لینک سازی">
<LinkAnalyse2 :items="link_analyse_items" />
          </CTab>
          <CTab title="سئو انجین 2">
<TopicClusterLinkAnalysis4 :items="link_analyse_items" />
          </CTab>
          <CTab title="سئو انجین">
            <TopicClusterLinkAnalysis :items="link_analyse_items" />
          </CTab>
          <CTab title="تاپیک کلاسترینگ">
<TopicClusterLinkAnalysis2 :items="link_analyse_items" />
          </CTab>
          <CTab title="درختواره کلاسترینگ">
<TopicClusteringTree :items="link_analyse_items" />
          </CTab>

        </CTabs>

      </CCardBody>
    </CCard>

  </div>

</template>

<script>
import axios from "@/api/http";
import {bus} from "../../main";
import {CChartLineSimple} from "@/views/charts";
import {parser_config_in_site, custom_parser_config_in_site} from "@/plugins/editorjs_config";
import LinkAnalyse2 from "./LinkAnalyse2.vue";
import TopicClusterLinkAnalysis4 from "./TopicClusterLinkAnalysis4.vue";
import TopicClusterLinkAnalysis2 from "./TopicClusterLinkAnalysis2.vue";
import TopicClusterLinkAnalysis3 from "./TopicClusterLinkAnalysis3.vue";
import TopicClusterLinkAnalysis from "./SeoEngine/TopicClusterLinkAnalysis.vue";
import TopicClusteringTree from "./TopicClusteringTree.vue";
import BlogSeoRank from "./BlogSeoRankComponent.vue";
export default {
  name: 'Login',
  components: {
    BlogSeoRank,
    TopicClusteringTree,
    LinkAnalyse2,
    TopicClusterLinkAnalysis,
    TopicClusterLinkAnalysis4,
    TopicClusterLinkAnalysis2,
    TopicClusterLinkAnalysis3,
    CChartLineSimple
    // Use the <ckeditor> component in this view.
    // ckeditor: CKEditor.component
  },
  data() {
    return {

      product_views_list: [],
      post_views_list: [],
      product_views_list_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'views_last_7_days', label: 'بازدید 7 روز گذشته', _classes: 'text-center'},
        {key: 'views_7_to_14_days', label: 'بازدید 14 روز گذشته', _classes: 'text-center'},
        {key: 'change_day', label: 'تغییر', _classes: 'text-center'},
        {key: 'views_last_month', label: 'بازدید 1 ماه گذشته', _classes: 'text-center'},
        {key: 'views_1_to_2_months', label: 'بازدید 2 ماه گذشته', _classes: 'text-center'},
        {key: 'change_month', label: 'تغییر', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],

      product_views_perday: [],
      post_views_perday: [],

      product_views_perday_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'total_views', label: 'بازدید کل', _classes: 'text-center'},
        {key: 'views_per_day', label: 'بازدید / روز', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      product_faravani: [],
      product_faravani_fields: [
        {key: 'row_id', label: '#', _classes: 'text-center'},
        {key: 'title', label: 'عنوان'},
        {key: 'usage_count', label: 'تعداد استفاده شده', _classes: 'text-center'},
        {key: 'operation', label: 'عملیات'},
      ],
      blog_posts: [],

      products: [],
      link_analyse_items: [],
      parser: null,

    }
  },
  mounted() {
    this.parser = new edjsParser(parser_config_in_site, custom_parser_config_in_site, {});

    this.get_view_list_data();
    this.get_view_list_perday();
    this.get_products_faravani();
    this.get_blogs_seo();

  },
  watch: {},
  methods: {
    show_blog_post(item) {
      window.open(localStorage.getItem("web_address") + "blog/" + item.slug, "_blank");

    },
    edit_blog_post(item) {
      this.$router.push({path: '/dashboard/news/edit-news/' + item.source})
    },
    get_view_list_data() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_view_list_data', form_data, {}).then(function (response) {
        response.data.products.forEach(function (val) {
          val.change_day = self.calculatePercentageChange(val.views_last_7_days, val.views_7_to_14_days)
          val.change_month = self.calculatePercentageChange(val.views_last_month, val.views_1_to_2_months)
        })
        response.data.posts.forEach(function (val) {
          val.change_day = self.calculatePercentageChange(val.views_last_7_days, val.views_7_to_14_days)
          val.change_month = self.calculatePercentageChange(val.views_last_month, val.views_1_to_2_months)
        })
        self.product_views_list = response.data.products
        self.post_views_list = response.data.posts

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_view_list_perday() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_view_list_perday', form_data, {}).then(function (response) {


        self.product_views_perday = response.data.products
        self.post_views_perday = response.data.posts

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_products_faravani() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_products_faravani', form_data, {}).then(function (response) {


        self.product_faravani = response.data.products

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_blogs_seo() {
      var self = this;
      var form_data = new FormData();
      axios.post('/api/admin/seo_report/get_blogs_seo', form_data, {}).then(function (response) {
        response.data.posts.forEach(function (val) {
          self.link_analyse_items.push(
              {
                type: 'article', // یا 'product'
                htmlContent: self.parser.parse(JSON.parse(val.description)),
                keyword: val.keyword,
                title: val.title,
                source: val.source,
                meta_description: val.short_description,
                seo_title: val.seo_title,
                category: val.categories,
                tags: val.tags,
                url: '/blog/' + val.slug // یا '/product/sample-product'
              }
          )


        })
        response.data.products.forEach(function (val) {
          self.link_analyse_items.push(
              {
                type: 'product', // یا 'product'
                htmlContent: self.parser.parse(JSON.parse(val.description)),
                keyword: val.keyword,
                title: val.title,
                source: val.source,
                meta_description: val.short_description,
                seo_title: val.seo_title,
                category: [],
                tags: val.tags,
                url: '/product/' + val.slug // یا '/product/sample-product'
              }
          )


        })
        self.blog_posts = response.data.posts

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    calculatePercentageChange(viewsLast7Days, views7To14Days) {
      // چک کردن اینکه مقدار قدیم صفر نباشد (برای جلوگیری از تقسیم بر صفر)
      if (views7To14Days == 0) {
        if (viewsLast7Days == 0) return 0; // اگر هر دو صفر باشند، تغییر 0%
        return viewsLast7Days > 0 ? 100 : -100; // اگر قدیم صفر و جدید مثبت/منفی باشد
      }

      // محاسبه درصد تغییر
      const change = ((viewsLast7Days - views7To14Days) / views7To14Days) * 100;

      // گرد کردن به 2 رقم اعشار
      return Number(change.toFixed(2));
    },

  }
}


</script>
